

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getVendorsByLocation } from '@/api/vendors'

@Component({
  name: 'VendorSelect'
})
export default class extends Vue {
  @Prop({ required: true }) private value!: number
  @Prop({ required: true }) private orderId!: number
  @Prop({ required: true }) private latitude!: number
  @Prop({ required: true }) private longitude!: number
  @Prop({ required: false, default: false }) private disableCTA: boolean

  mounted() {
    this.$nextTick(() => {
      this.fetchData()
    })
  }

  private options = []
  private locationFilter: any = null

  @Watch('orderId')
  private updateOptions = () => {
    if (this.orderId) {
      this.fetchData()
    }
  };

  private async fetchData() {
    const filter = { orderId: this.orderId, latitude: this.latitude, longitude: this.longitude, distance: 0 }
    if (!filter.latitude || !filter.longitude) return
    if (this.locationFilter == null || this.locationFilter.latitude !== filter.latitude) {
      this.locationFilter = Object.assign({}, filter)
      try {
        const { data } = await getVendorsByLocation(filter)
        this.options = data
      } catch (err) {
        console.error(err)
      }
    }
  }

  handleAssignVendor() {
    this.$emit('assignVendor', this.value)
  }

  updateNewVendor(vendorId: number) {
    this.$emit('updateNewVendor', vendorId)
  }

  get vendorId() {
    return this.value
  }

  set vendorId(updated) {
    this.$emit('input', updated)
  }
}
